import en from 'assets/i18n/en.json';
import fr from 'assets/i18n/fr.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LanguageService } from 'services/language-service';
import { LANGUAGES } from 'shared/constants/languages';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n.use(initReactI18next).init(
  {
    resources: {
      en: {
        translation: en
      },
      fr: {
        translation: fr
      }
    },
    fallbackLng: LANGUAGES.english,
    lng: LanguageService.getCurrentLanguage(),
    interpolation: {
      escapeValue: false
    },
    returnNull: false
  },
  () => LanguageService.initLanguage()
);

export default i18n;
